/**
 * Пароль для новой или ещё не сохранённой карточки: генерируется в браузере и уходит
 * на сервер вместе с карточкой (поле нового пароля). Правила те же, что у сервера
 * (RegeneratePasswordCommandHandler): от 10 символов, цифры, строчные и прописные латинские.
 */

const LOWER = "abcdefghijkmnpqrstuvwxyz";
const UPPER = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const DIGITS = "23456789";
const ALL = LOWER + UPPER + DIGITS;

export const PASSWORD_LENGTH = 12;

const pick = (alphabet: string) => {
  const buffer = new Uint32Array(1);
  // отбрасываем хвост диапазона, чтобы не было смещения по модулю
  const limit = Math.floor(0x100000000 / alphabet.length) * alphabet.length;
  do {
    crypto.getRandomValues(buffer);
  } while (buffer[0] >= limit);

  return alphabet[buffer[0] % alphabet.length];
};

export const generatePassword = (length = PASSWORD_LENGTH) => {
  // по символу каждого вида гарантированно, остальное - из общего набора
  const chars = [pick(LOWER), pick(UPPER), pick(DIGITS)];
  while (chars.length < length) {
    chars.push(pick(ALL));
  }

  // перемешиваем, чтобы обязательные символы не стояли всегда в начале
  for (let i = chars.length - 1; i > 0; i--) {
    const j = ALL.indexOf(pick(ALL)) % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join("");
};
